export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9295.032af44a.jpg";